import axios from "axios";
import { APIBaseURL, createUserURL, createUserWithCentreURL, deleteUserURL, getAllUsersURL, getCentreAdminsURL, getFranchiseAdminsURL, getUserByIdURL, getUserCentresByRoleURL, updateUserPasswordURL, updateUserProfileURL, updateUserURL, updateUserWithCentreURL, userDBSURL, userMentorCentresURL, viewUserByIdURL } from "@app/constants/ApiEndPoints";

export const getUsersWithPagination = async (page, perPage, sortField, sortDirection, search) => {
	try {
		const response = await axios.get(getAllUsersURL + `?page=${page}&perPage=${perPage}&sortField=${sortField}&sortDirection=${sortDirection}&firstName=${search.firstName}&lastName=${search.lastName}&email=${search.email}&phone=${search.phone}&role=${search.role}&status=${search.status}&franchiseId=${search.franchiseId || ''}&centreId=${search.centreId || ''}`);
		if (response.status === 200) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createUser = async (payload) => {
	try {
		const response = await axios.post(createUserURL, payload);
		if (response.status === 201 /*&& response.statusText === "Created"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getUserById = async (id: number) => {
	try {
		const response = await axios.get(getUserByIdURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUser = async (id, payload) => {
	try {
		const response = await axios.put(updateUserURL + id, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteUserById = async (id: number) => {
	try {
		const response = await axios.delete(deleteUserURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data;
		}
		return response?.data;
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserPassword = async (payload) => {
	try {
		const response = await axios.patch(updateUserPasswordURL, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserProfile = async (payload) => {
	try {
		const response = await axios.patch(updateUserProfileURL, payload);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getFranchiseAdmins = async () => {
	try {
		const response = await axios.get(getFranchiseAdminsURL);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getCentreAdmins = async () => {
	try {
		const response = await axios.get(getCentreAdminsURL);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const viewUserById = async (id: number) => {
	try {
		const response = await axios.get(viewUserByIdURL + id + '/view');
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getDBSByUserId = async (id: number) => {
	try {
		const response = await axios.get(userDBSURL + id);
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserDBSDetails = async (id, payload) => {
	try {
		const response = await axios.put(userDBSURL + id, payload);
		if (response.status === 201 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getDBSDocumentById = async (docId: number) => {
	try {
		const response = await axios.get(userDBSURL + 'document/' + docId, { responseType: 'blob' });
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const deleteDBSDocumentById = async (docId: number) => {
	try {
		const response = await axios.delete(userDBSURL + 'document/' + docId);
		if (response.status === 201 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getDBSUsersByFranchiseId = async (franchise_id: number) => {
	try {
		const response = await axios.get(userDBSURL + 'franchise/' + franchise_id );
		if (response.status === 200 /*&& response.statusText === "OK"*/) {
			return response.data
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserSafeguarding = async (id, payload) => {
	try {
		const response = await axios.post(userDBSURL + id + '/safeguarding', payload);
		if (response.status === 201) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserPVG = async (id, payload) => {
	try {
		const response = await axios.post(userDBSURL + id + '/pvg', payload);
		if (response.status === 201) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const createUserWithCentre = async (payload) => {
	try {
		const response = await axios.post(createUserWithCentreURL, payload);
		if (response.status === 201) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

// Updates a user's profile fields and, for a single role, replaces the
// centres granted under that role. Roles are only ever added (never
// removed) and centres held under any other role of the user's are left
// untouched -- this is what lets us edit one centre-role assignment (e.g.
// Centre Manager) without disturbing an unrelated one (e.g. Mentor) or any
// FMS-A role the user may also hold.
export const updateUserWithCentreRole = async (payload) => {
	try {
		const response = await axios.post(updateUserWithCentreURL, payload);
		if (response.status === 200 || response.status === 201) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

// Reads the centres (and franchises) a user holds under one specific role.
// Used to pre-fill the centre picker when editing that role's assignment,
// since a centre-scoped staff list (getCentreUsers) only reflects the
// centre currently being viewed, not every centre the user holds this role
// at.
export const getUserCentresByRole = async (id: number, roleId: number) => {
	try {
		const response = await axios.get(`${getUserCentresByRoleURL}${id}/centres/${roleId}`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getUserMentorCentres = async (id: number) => {
	try {
		const response = await axios.get(`${userMentorCentresURL}${id}/mentor-centres`);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const updateUserMentorCentres = async (id: number, payload: { centre_ids: number[] }) => {
	try {
		const response = await axios.put(`${userMentorCentresURL}${id}/mentor-centres`, payload);
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		return error?.response?.data;
	}
};

export const getUsersByFranchiseId = async (franchiseId: number, roles?: string[]) => {
	try {
		const params = new URLSearchParams();
		if (roles && roles.length > 0) {
			roles.forEach(r => params.append('roles[]', r));
		}
		// Assign Existing User (ViewCentre) must also offer users whose grant
		// was detached, not just currently-active ones.
		params.append('include_detached', 'true');
		const query = params.toString() ? `?${params.toString()}` : '';
		const response = await axios.get(`${APIBaseURL}/admin/franchise/${franchiseId}/users${query}`);
		if (response.status === 200) return response.data;
	} catch (error) {
		return error?.response?.data;
	}
};
